import { render, staticRenderFns } from "./BaseRadiolist.vue?vue&type=template&id=25b7f392&scoped=true"
import script from "./BaseRadiolist.vue?vue&type=script&lang=js"
export * from "./BaseRadiolist.vue?vue&type=script&lang=js"
import style0 from "./BaseRadiolist.vue?vue&type=style&index=0&id=25b7f392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b7f392",
  null
  
)

export default component.exports